import { Component, inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FileParamsFormComponent } from '../../../shared/components/file-params-form/file-params-form.component';
import { UploadShapefileComponent } from '../../../shared/components/upload-shapefile/upload-shapefile.component';
import { OrpcService } from '../../../shared/services/orpc-client.service';
import { Router } from '@angular/router';
import { SnackbarService } from '../../../shared/services/snackbar.service';
import { FeatureFlagsService } from '../../../shared/services/feature-flags.service';
import { downloadBlobWithAnchor } from '../../../shared/utils/file-download';

@Component({
  selector: 'app-compliance-new',
  imports: [
    FileParamsFormComponent,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatProgressSpinnerModule,
    UploadShapefileComponent,
  ],
  templateUrl: './compliance-new.component.html',
  styleUrl: './compliance-new.component.scss',
})
export class ComplianceNewComponent {
  @ViewChild(FileParamsFormComponent)
  declare formComponent: FileParamsFormComponent;
  @ViewChild(UploadShapefileComponent)
  declare fileComponent: UploadShapefileComponent;
  isDownloading = false;
  isLoading = false;
  private orpc = inject(OrpcService);
  private router = inject(Router);
  private snackBar = inject(SnackbarService);
  private featureFlags = inject(FeatureFlagsService);

  // Expor para o template
  get enabledFileTypes() {
    return this.featureFlags.getComplianceEnabledFileTypes();
  }

  async downloadTemplate() {
    this.isDownloading = true;
    try {
      const response = await this.orpc.client.requestTemplate.download({
        module: 'compliance',
      });

      downloadBlobWithAnchor(response.blob, response.filename);
    } finally {
      this.isDownloading = false;
    }
  }
  onSubmit() {
    this.formComponent.form.markAllAsTouched();
    this.fileComponent.fileCtrl.markAllAsTouched();
    if (
      this.formComponent.form.invalid ||
      this.fileComponent.fileCtrl.invalid
    ) {
      return;
    }
    const params = this.formComponent.form.value;
    this.isLoading = true;
    this.orpc.client.socEnvAnalysis
      .request({
        fileName: this.uploadedFileName!,
        originalFileName: this.originalFileName ?? undefined,
        featurePrimaryKeyField: params.featurePrimaryKey!,
        identityDocumentField: params.identityDocument ?? undefined,
        producerField: params.producer ?? undefined,
        carFieldKey: params.car ?? undefined,
        contractFieldKey: params.contract ?? undefined,
        insurancePolicyKey: params.insurancePolicy ?? undefined,
        customerFarmNameKey: params.farmName ?? undefined,
      })
      .then((res) => {
        this.snackBar.alert(
          `Solicitação ${res.requestId} registrada com sucesso.`,
          -1,
        );
        this.router.navigate(['compliances']);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  uploadedFileName: string | null = null;
  originalFileName: string | null = null;
  fileType: string | null = null;

  onFileUploaded(fileName: string | null) {
    this.uploadedFileName = fileName;
  }

  onOriginalFileName(originalName: string | null) {
    this.originalFileName = originalName;
  }

  onFileTypeChanged(fileType: string | null) {
    this.fileType = fileType;
  }

  onNavigateUp() {
    this.router.navigate(['compliances']);
  }
}
